import { createSelector } from '@reduxjs/toolkit';
import { createApi, SELECTOR, setSelector } from '@socialive/common';
import selectApiBaseUrl from './selectApiBaseUrl';
import selectAuthToken from './selectAuthToken';

const selectApi = createSelector(
  selectApiBaseUrl,
  selectAuthToken,
  (host, authToken) =>
    host &&
    authToken &&
    createApi({
      baseUrl: host,
      authorization: authToken,
    })
);

setSelector(SELECTOR.API, selectApi);

export default selectApi;
